

<template>
    <div>
        <modal height="auto" :name="modal_name" class="final-modal" transition="nice-modal-fade">
            <div class="v-modal-content p-0">
                <div class="v-modal-header v-modal-header-new-back" style="background-color:#00448b !important">
                    <span class="v-modal-dialog-title v-modal-title fw-600 py-3 ml-auto mr-auto text-uppercase" style="color: #fff !important;letter-spacing:1px;">Request access</span>
                    <button  type="button" class="pointer position-absolute" style="background-color: #00448b !important;outline:none; right: 0; top: 10px;" aria-label="Close" @click="hideRequestAccess()">
                        <span aria-hidden="true">
                            <i class="icon icon-close" style="color:white;margin:10px 10px 0 0;"></i>
                        </span>
                    </button>
                </div>
                <div class="m-4">
                    <div class="v-modal-body pt-0 pb-0" style="max-height:430px;overflow-y:auto;overflow-x:auto;">
                        <img src="/static/images/Parrot 1@3x.png" style="margin:0 auto;display:block;" width="100px" alt="">
                        <p class="text-center fw-500 pt-4">Request access to give " {{product_name || "-"}} " Access</p>
                        <div class="d-flex flex-column px-10">
                            <span class="mb-1 text-secondary">Add Comment</span>
                            <textarea style="border:1px solid #000;height:70px;border-radius:5px;padding:5px;" :maxlength="200" v-model="comment" placeholder="Enter text here"></textarea>
                            <span style="place-self:end">{{comment.length}}/200</span>
                            <h1 class="text-danger fs-14">{{error_text}}</h1>
                        </div>
                    </div>
                    <div class="v-modal-dialog-actions text-center" style="border-radius: 0px 0px 15px 15px;padding:15px;">
                        <a class="btn btn-danger btn-smm text-white" style="text-transform: uppercase !important;font-size: 12px !important;border-radius:5px !important;" @click="hideRequestAccess()">CANCEL</a>
                        <a class="btn btn-secondary btn-smm text-white ml-2" style="text-transform: uppercase !important;font-size: 12px !important;border-radius:5px !important;" @click="sendRequestAccess()">SEND</a>
                    </div> 
                </div>     
            </div>
        </modal>
    </div>
</template>

<script>

export default {
    props:['modal_name', 'product_id', 'error_text', 'product_name'],
    data(){
        return{
            comment: ''
        }
    },
    methods: {
        hideRequestAccess(){
            this.$emit('hideRequestAccess');
        },
        sendRequestAccess() {
            // console.log(this.$route.params.company_id);
            let data = {
                comment: this.comment,
                product_id: this.product_id,
                company_id: this.loggedInUser.company_id
            }
            this.$emit('sendRequestAccess', data);
        }

    },
    computed: {
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        }
    },
}

</script>

<style scoped>

.v-modal-header{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 20px;
}
.v-modal-content{
    padding: 5px;
}
.v-modal-body div form{
    display: flex;
    flex-direction: column;
}

.v-modal-body div input{
    margin-bottom: 10px;
    padding: 10px;
    outline: none;
    border-radius: 5px;
    border: 1px solid black;
    opacity: 0.71
}

</style>
